import { render, staticRenderFns } from "./FieldSortOrder.vue?vue&type=template&id=7a488ea8&scoped=true"
import script from "./FieldSortOrder.vue?vue&type=script&lang=js"
export * from "./FieldSortOrder.vue?vue&type=script&lang=js"
import style0 from "./FieldSortOrder.vue?vue&type=style&index=0&id=7a488ea8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a488ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a488ea8')) {
      api.createRecord('7a488ea8', component.options)
    } else {
      api.reload('7a488ea8', component.options)
    }
    module.hot.accept("./FieldSortOrder.vue?vue&type=template&id=7a488ea8&scoped=true", function () {
      api.rerender('7a488ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldSortOrder.vue"
export default component.exports